module.exports = __webpack_public_path__ + "static/img/沈峰.442cbc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/沈峰.jpg
// module id = lbmU
// module chunks = 139